
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Urbanialuxurybusrentalsinpune() {



  const cardData =
  {
    keyword: ' Urbania Luxury Bus Rentals in Pune',
    heading: 'Vaishnavi Travels: Urbania Luxury Bus Rentals in Pune',
    headingDescription: 'Vaishnavi Travels provides premium Urbania Luxury Bus Rentals in Pune, perfect for weddings, corporate events, family tours, and long outstation journeys. Our luxury Urbania buses are equipped with plush push-back seats, modern interiors, strong air-conditioning, and ample luggage space, ensuring a smooth and comfortable travel experience for every passenger. With professional chauffeurs, on-time pickups, and flexible booking options, we make group travel stylish and stress-free. Whether it’s a business trip, holiday vacation, or religious yatra, Vaishnavi Travels guarantees safe, reliable, and elegant Urbania luxury bus rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace and a proud reminder of Maratha glory. Once the political seat of the Maratha Empire, it features massive gates, gardens, and ancient ruins. Though partially destroyed by fire in 1828, its aura still captivates visitors. The evening light-and-sound show brings alive tales of Bajirao and Mastani. Tourists explore its courtyards, fountains, and hidden pathways. Shaniwar Wada is Pune’s historic and cultural crown jewel."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument tied to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The palace today houses a museum with Gandhi’s personal belongings, photos, and letters. Its sprawling gardens and arches create a serene retreat. Tourists and students come here to connect with history and patriotism. Aga Khan Palace is Pune’s inspirational heritage site of sacrifice and pride."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a hilltop stronghold famous for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. Trekkers climb to the fort for breathtaking views of the Sahyadri ranges. Inside, visitors explore bastions, temples, and memorials echoing Maratha bravery. Monsoon adds misty waterfalls and lush greenery to the trek. Local villagers serve traditional pithla-bhakri, adding flavor to the experience. Sinhagad Fort is Pune’s mix of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The magnificent idol is adorned with gold and jewels, drawing thousands daily. During Ganesh Chaturthi, the temple becomes the epicenter of colorful festivities. Known for its charitable and cultural contributions, it is a hub of devotion and service. Devotees feel immense spiritual energy in its presence. Dagdusheth Ganpati Temple is Pune’s spiritual and cultural heartbeat."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features large stone pillars, sanctum chambers, and a Nandi mandapa. Despite being located in the busy city center, it provides peace and meditation. Evening chants create a mystical ambiance. The temple is admired for its ancient craftsmanship and simplicity. Pataleshwar Cave Temple is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a treasure trove of over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include ornaments, musical instruments, sculptures, and everyday antiques from across India. The recreated Mastani Mahal is a highlight for history lovers. Students and tourists find the museum both educational and fascinating. It preserves centuries of Indian artistry under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of culture and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers a panoramic view of the city. At the top stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati. Smaller shrines and museums nearby add cultural richness. Pilgrims climb 103 steps to reach the temple, blending devotion with fitness. Sunrise and sunset views from here are truly mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global wellness hub. Spread across lush gardens, it attracts seekers from all over the world. The ashram offers meditation techniques, yoga, and personal growth workshops. Its Japanese Zen gardens and serene halls create a peaceful environment. Beyond spirituality, it is also a rejuvenation retreat for modern lifestyles. Osho Ashram is Pune’s international destination for peace and mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, also known as Okayama Friendship Garden, is Pune’s largest landscaped park inspired by Japan’s Korakuen Garden. It features flowing streams, stone bridges, and manicured lawns. Families enjoy picnics, photography, and peaceful walks here. The garden also symbolizes Indo-Japanese friendship and cultural ties. Seasonal flowers add vibrant beauty throughout the year. Pu La Deshpande Garden is Pune’s green paradise of tranquility."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend retreat near Pune. It supplies water to the city while offering scenic views of hills and flowing waters. During monsoon, the overflowing dam creates a mesmerizing spectacle. Families enjoy roasted corn and tea from roadside stalls along the banks. It also serves as the gateway to Sinhagad Fort treks. Khadakwasla Dam is Pune’s refreshing natural escape for relaxation."
  }
],


      "services": [
    {
      "name": "Luxury Urbania Bus Pune",
      "description": "Experience premium travel in Pune with our Luxury Urbania buses, designed to provide the utmost comfort and style for your journeys. Featuring plush leather seating, ambient LED lighting, advanced climate control, and superior soundproofing, these vans cater perfectly to executive travel, VIP outings, and special events. Whether you’re heading to corporate meetings, weddings, or city tours, our luxury Urbania buses ensure a first-class ride with professional drivers and personalized service."
    },
    {
      "name": "Executive Van Rentals Urbania",
      "description": "Our Executive Urbania van rentals in Pune offer a sophisticated travel solution for business professionals and corporate groups. Equipped with Wi-Fi connectivity, charging ports, reclining seats, and tinted windows, these vans create a productive and relaxing environment on the move. Ideal for airport transfers, client visits, seminars, and team outings, the executive vans combine comfort with punctuality and safety."
    },
    {
      "name": "13/17 Seater Urbania Bus Pune",
      "description": "Choose from spacious 13 or 17 seater Urbania vans in Pune that balance capacity and comfort. Perfect for family trips, small group tours, or corporate events, these vans are equipped with ergonomic seats, ample legroom, and modern amenities. Both AC and non-AC options are available to suit your preferences, with professional drivers ensuring timely and smooth travel experiences within Pune and beyond."
    },
    {
      "name": "Force Urbania with Driver Hire",
      "description": "Hire a Force Urbania van with an experienced driver for a hassle-free travel experience in Pune. Our drivers are trained for safe driving and customer service excellence, familiar with city routes and outstation highways. This service is perfect for weddings, corporate events, or long-distance trips, with packages including fuel, tolls, and driver allowances to provide transparent and comprehensive travel solutions."
    },
    {
      "name": "AC Luxury Urbania Rental Pune",
      "description": "Travel in cool luxury with our air-conditioned Urbania van rentals in Pune, specially designed for comfort during hot weather and long journeys. These vans feature efficient AC systems, premium upholstery, adjustable seating, and noise reduction technology. Ideal for family vacations, office outings, and special occasions, they ensure all passengers remain refreshed and comfortable throughout the ride."
    },
    {
      "name": "Premium Urbania for Corporate Travel",
      "description": "Elevate your corporate travel experience with our premium Urbania vans, tailored to meet the needs of business clients in Pune. These vans come with clean, spacious interiors, Wi-Fi, reading lights, and privacy curtains. Our corporate rental service guarantees punctual pickups, courteous drivers, and flexible scheduling for conferences, meetings, and corporate retreats."
    },
    {
      "name": "Family Urbania Van in Pune",
      "description": "Plan memorable family outings in Pune with our Family Urbania vans, offering safe and comfortable travel for all age groups. Equipped with child safety locks, entertainment systems, and ample storage space for luggage and picnic gear, these vans are ideal for religious trips, hill station tours, or weekend getaways. Drivers are courteous and experienced in family travel needs."
    },
    {
      "name": "VIP Urbania Van Booking Pune",
      "description": "Book VIP Urbania vans in Pune for luxurious and discreet transportation services. Perfect for celebrities, executives, and special guests, these vans offer premium interiors, privacy features, and personalized services such as onboard refreshments and chauffeur attire. Our VIP bookings ensure timely arrivals and departures with the highest standards of safety and professionalism."
    },
    {
      "name": "Outstation Luxury Urbania Van",
      "description": "Experience luxury travel beyond Pune with our outstation Urbania vans, designed for long-distance comfort. Featuring spacious seating, advanced climate control, and onboard amenities, these vans are perfect for weekend getaways, religious pilgrimages, and business tours. Our service includes experienced drivers, fuel management, and trip support to ensure a seamless journey."
    },
    {
      "name": "Urbania for Wedding Transport Pune",
      "description": "Make your wedding transport hassle-free and stylish with our Urbania vans in Pune. Perfect for transporting family members, guests, or bridal parties, these vans come with festive decorations, soft music systems, and uniformed drivers. Available for full-day or event-based rentals, we ensure timely pickups and drop-offs across multiple wedding venues."
    },
    {
      "name": "Pune City Travel in Urbania",
      "description": "Explore Pune in comfort with our Urbania vans tailored for city travel. Whether for sightseeing, shopping trips, or daily commutes, these vans provide ample space, easy boarding, and smooth rides through urban traffic. Available with flexible booking options, our drivers know Pune’s routes well and offer courteous, safe travel services."
    },
    {
      "name": "Group Luxury Bus Hire Pune",
      "description": "Organize group travel in Pune with our luxury Urbania buses that combine capacity with high-end comfort. Ideal for corporate groups, social clubs, or large family gatherings, these buses feature premium seating, entertainment options, and climate control. We provide customized packages including multi-day rentals, sightseeing tours, and event transport with professional drivers."
    },
    {
      "name": "Urbania Tour Van Rentals Pune",
      "description": "Book Urbania vans for tour rentals in Pune, perfect for exploring local attractions, nearby hill stations, and cultural sites. Our vans come equipped with panoramic windows, comfortable seating, and driver guides (optional) to enhance your sightseeing experience. Flexible packages available for day trips, weekend excursions, and longer tours with family or friends."
    }
  ],
  "tableData": [
    ["Luxury Urbania Bus Pune", "Executive Van Rentals Urbania"],
    ["13/17 Seater Urbania Bus Pune", "Force Urbania with Driver Hire"],
    ["AC Luxury Urbania Rental Pune", "Premium Urbania for Corporate Travel"],
    ["Family Urbania Van in Pune", "VIP Urbania Van Booking Pune"],
    ["Outstation Luxury Urbania Van", "Urbania for Wedding Transport Pune"],
    ["Pune City Travel in Urbania", "Group Luxury Bus Hire Pune"],
    ["Urbania Tour Van Rentals Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Urbania Luxury Bus Rentals in Pune",
    "WhyChoosedescription": "Vaishnavi Travels provides top-notch Force Urbania luxury bus rentals in Pune, perfect for premium travel, corporate events, and VIP group outings."
  },
  {
    "WhyChooseheading": "Premium Comfort and Modern Amenities",
    "WhyChoosedescription": "Our Urbania luxury buses feature leather seating, individual AC vents, LED lighting, USB charging ports, and advanced suspension for a smooth ride."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each luxury Urbania bus is regularly serviced and thoroughly cleaned to ensure the highest standards of hygiene and safety."
  },
  {
    "WhyChooseheading": "Experienced Chauffeurs with Professional Service",
    "WhyChoosedescription": "Our drivers are trained for luxury service, ensuring punctuality, safety, and courteous behavior throughout your journey."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Every Occasion",
    "WhyChoosedescription": "Choose from hourly, daily, or multi-day rentals tailored to corporate events, weddings, group tours, and more."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Our all-inclusive pricing covers fuel, tolls, taxes, and driver allowances, providing a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Travel, VIP Transfers, and Special Events",
    "WhyChoosedescription": "Perfect for business executives, celebrity transport, weddings, and exclusive group travel in Pune."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Smooth Booking",
    "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist with bookings, itinerary planning, and travel assistance."
  }
]
















  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer luxury Urbania bus rentals in Pune?',
      answer: 'Yes, Vaishnavi Travels provides luxury 13 seater Force Urbania bus rentals in Pune, perfect for premium group travel, corporate events, and special occasions requiring comfort and style.',
    },
    {
      question: 'What luxury features are available in the Urbania buses offered by Vaishnavi Travels in Pune?',
      answer: 'Our luxury Urbania buses come equipped with spacious leather seats, advanced air-conditioning, modern interiors, entertainment systems, ample legroom, and superior suspension for a smooth and comfortable ride.',
    },
    {
      question: 'Are the luxury Urbania buses well-maintained and driven by professional chauffeurs?',
      answer: 'Absolutely! All luxury Urbania buses are meticulously maintained and regularly serviced. Our experienced and courteous drivers ensure a safe, punctual, and professional travel experience.',
    },
    {
      question: 'What is the rental cost for luxury Urbania bus rentals in Pune?',
      answer: 'Rental costs for luxury Urbania buses typically start from ₹6,000 per half-day rental, varying based on duration, distance, and any additional premium services requested.',
    },
    {
      question: 'Can I book luxury Urbania buses for outstation trips from Pune?',
      answer: 'Yes, Vaishnavi Travels offers luxury Urbania bus rentals for both local and outstation trips with customized packages to meet your specific requirements.',
    },
    {
      question: 'How early should I book a luxury Urbania bus rental in Pune?',
      answer: 'It is recommended to book at least 4-5 days in advance, especially during peak seasons and special events, to ensure availability.',
    },
    {
      question: 'Is flexible pickup and drop-off available for luxury Urbania bus rentals in Pune?',
      answer: 'Yes, flexible pickup and drop locations within Pune and surrounding areas are available to best suit your travel plans.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Kiran Joshi",
    position: "Event Manager",
    feedback:
      "Vaishnavi Travels’ luxury Urbania bus rental was perfect for our corporate event in Pune. The vehicle was stylish, comfortable, and the driver was highly professional.",
    rating: 5,
  },
  {
    name: "Ms. Shruti Patil",
    position: "Wedding Planner",
    feedback:
      "We booked a luxury Urbania from Vaishnavi Travels for a wedding event. The bus was spacious, elegant, and provided a fantastic travel experience for our guests. Highly recommended!",
    rating: 5,
    style: "style-2",
  }
];





































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Luxury Bus Rentals in Pune",
  "image": "https://vaishnavitravel.com/assets/images/luxury-urbania-bus-pune.jpg",
  "description": "Rent premium 13/17 seater Force Urbania luxury vans in Pune with AC options. Perfect for corporate travel, weddings, VIP transport, family tours, and outstation trips with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8500",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/luxury-urbania-bus-rentals-pune"
  }
};





  return (
    <div>

<Helmet>
  <title>Urbania Luxury Bus Rentals in Pune | Premium 13/17 Seater Vans</title>
  <meta
    name="description"
    content="Rent premium 13/17 seater Force Urbania luxury vans in Pune with AC options. Perfect for corporate travel, weddings, VIP transport, family tours, and outstation trips with experienced drivers."
  />
  <meta
    name="keywords"
    content="Luxury Urbania Bus Pune, Executive Van Rentals Urbania, 13/17 Seater Urbania Bus Pune, Force Urbania with Driver Hire, AC Luxury Urbania Rental Pune, Premium Urbania for Corporate Travel, Family Urbania Van in Pune, VIP Urbania Van Booking Pune, Outstation Luxury Urbania Van, Urbania for Wedding Transport Pune, Pune City Travel in Urbania, Group Luxury Bus Hire Pune, Urbania Tour Van Rentals Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/46.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbanialuxurybusrentalsinpune;